<template>
  <div>
    <Content title="SLA Performance Registrasi Vendor Baru & SAP" />
  </div>
</template>
<script>
export default {
  components: {
    Content: () => import('@/components/dashboard/main-kpi/content.vue'),
  },
}
</script>
